import ApiError from 'utils/api/errors/ApiError';


class ApiPermissionDeniedError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiPermissionDeniedError';
  }
}

export default ApiPermissionDeniedError;
